import React  from 'react';
import PropTypes from 'prop-types';

const SearchItem = (props) => {

    function selectCountry() {
        props.select(props.isocode, props.country, props.validItem)
    }
    const isValid = props.validItem ? '' : 'error';
    return (
        <div onClick={selectCountry} className={`${isValid}`}>
             {props.country}
        </div>
    )
    
}

export default SearchItem;

SearchItem.propTypes = {
    country: PropTypes.string,
    select: PropTypes.func.isRequired,
    isocode: PropTypes.string.isRequired,
    validItem: PropTypes.bool
}